import { UserActivityFeature } from '@datum-group/datum-map/lib/types';
import { MouseController } from '.';
import { IEventsItem, IEventsItemProperties } from '../EventsOpen/types';
import { SingleWindow } from '../Window';

export class EventsCardMouseControllerLink {
  constructor(
    private _mouseController: MouseController,
    private _card: SingleWindow<IEventsItemProperties>,
  ) {}

  bind = () => {
    this._mouseController.on('left_click', this._handler);

    return this.unbind;
  };

  unbind = () => {
    this._mouseController.un('left_click', this._handler);
  };

  private _handler = (targetData: UserActivityFeature) => {
    const [, feature] = targetData;

    if (this._isEventsCard(feature)) {
      this._card.open(feature.properties);

      return;
    }
  };

  private _isEventsCard = (
    value: GeoJSON.Feature<GeoJSON.Geometry | null>,
  ): value is IEventsItem => {
    if (value.id === undefined || !Number.isInteger(+value.id)) return false;

    const { properties } = value;

    if (!properties) return false;

    const hasEventsProps =
      'title' in properties &&
      'description' in properties &&
      'locations' in properties &&
      'sale_link' in properties &&
      'date_start' in properties &&
      'date_end' in properties &&
      'seance_schedule' in properties &&
      'max_price' in properties;

    return hasEventsProps;
  };
}
